import React from "react";
import "./About.css";
import SiteHeader from "./../../components/SiteHeader";
import Age from "./../../components/Age";

const AboutGr = () => {
  return (
    <main className="about">
      <SiteHeader current="about" />
      {/* Εισαγωγή */}
      <section className="about__hero container mt-5">
        <div className="about__intro">
          <h1 className="about__title">Σχετικά με εμένα</h1>
          <p className="about__lead mt-5">
            Γεια σας! Είμαι η <strong>Καΐπη Μαρία Ισμήνη</strong>, είμαι <Age/> και έχω μια τεράστια αγάπη για το πινγκ πονγκ.
          </p>
          <p>
            Γεννήθηκα με το σύνδρομο <strong>Holt-Oram</strong>, το οποίο επηρεάζει τα άνω άκρα και την καρδιά. Όπως μπορείτε να δείτε στις φωτογραφίες, έχω μικρά αλλά πλήρως λειτουργικά χέρια και, δόξα τω Θεώ, η καρδιά μου είναι πιο υγιής και πιο ζεστή από ποτέ!
          </p>
        </div>

        <div id="aboutCarousel" className="carousel slide about__portrait" data-bs-ride="carousel" data-bs-interval="2000">
          <div className="carousel-inner rounded-3 shadow-sm">
            <div className="carousel-item active">
              <img src="/images/profile.jpg" className="d-block w-100"   />
            </div>
            <div className="carousel-item">
              <img src="/images/profile1.jpg" className="d-block w-100"  />
            </div>
            <div className="carousel-item">
              <img src="/images/profile2.jpg" className="d-block w-100"  />
            </div>
          </div>

          {/* Optional controls */}
          <button className="carousel-control-prev" type="button" data-bs-target="#aboutCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Προηγούμενη</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#aboutCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Επόμενη</span>
          </button>

          <figcaption className="text-center mt-3 fst-italic text-muted">
            «Τίποτα δεν είναι ακατόρθωτο όταν το λέει η ψυχή σου.»
          </figcaption>
        </div>

      </section>

      {/* Ιστορία */}
      <section className="about__story container">
        <article className="card">
        <div className="row gx-5 align-items-center">
        <div className="col">
          <h2>Αρχή της διαδρομής</h2>
          <p>
            Το πάθος μου για το πινγκ πονγκ ξεκίνησε όταν βρέθηκα μπροστά σε ένα τραπέζι στις φοιτητικές εστίες όπου έμενα κατά τη διάρκεια των φοιτητικών μου χρόνων.
            Αρχικά, σιγά σιγά αλλά σταθερά, άρχισα να παίζω χωρίς να έχω καμία ιδιαίτερη ικανότητα. Έναν χρόνο αργότερα, αποφάσισα να γραφτώ σε μια ομάδα, ώστε να ξεκινήσω πιο επαγγελματικά τη μελέτη του αθλήματος.
          </p>
          <p>
            Και έτσι ξεκίνησα να ασχολούμαι πιο σοβαρά, μη χάνοντας προπόνηση, αφού το ενδιαφέρον μου ολοένα και αυξανόταν. Κάπως έτσι κατέβηκα το 2019 για πρώτη φορά στο <strong>Πανελλήνιο Πρωτάθλημα ΑΜΕΑ</strong>, όπου κατέκτησα την πρώτη θέση στο ατομικό και στα μεικτά.
          </p>
          <p>
            Παράλληλα με την αγωνιστική του Πανελληνίου, συμμετείχα και στο Πρωτάθλημα των Βετεράνων (ΠΟΦΕΠΑ), όπου είχα πολλούς αγώνες με σημαντικές νίκες.
          </p>
        </div>

        <div className="col">
          <div id="2019Carousel" className="carousel slide " data-bs-ride="carousel" >
            <div className="carousel-inner rounded-3 shadow-sm">
              <div className="carousel-item active">
                <img src="images\Πανελλήνιο2021.jpg" className="d-block w-100"   />
              </div>
              <div className="carousel-item">
                <img src="/images/Panellhnio2021.jpg" className="d-block w-100"  />
              </div>
            </div>

            {/* Optional controls */}
            <button className="carousel-control-prev" type="button" data-bs-target="#2019Carousel" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Προηγούμενη</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#2019Carousel" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Επόμενη</span>
            </button>

            <figcaption className="text-center mt-3 fst-italic text-muted">
              «Η χρονιά του 2019»
            </figcaption>
          </div>
          </div>
        </div>
        </article>

        <article className="card">
        <div className="row gx-5 align-items-center">
          
          <div className="col">
            <div id="2023Carousel" className="carousel slide " data-bs-ride="carousel" >
              <div className="carousel-inner rounded-3 shadow-sm">
                <div className="carousel-item active">
                  <img src="images/GreekParaOpen2023.jpg" className="d-block w-100"   />
                </div>
                <div className="carousel-item active">
                  <img src="images/Kefallonia2023.jpg" className="d-block w-100"   />
                </div>
                <div className="carousel-item">
                  <img src="images/Kefalonia2023_1.jpg" className="d-block w-100"  />
                </div>
                <div className="carousel-item">
                  <img src="images/medal_Argostoli2023.jpg" className="d-block w-100" style={{maxHeight:"400px"}} />
                </div>
              </div>

              {/* Optional controls */}
              <button className="carousel-control-prev" type="button" data-bs-target="#2023Carousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Προηγούμενη</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#2023Carousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Επόμενη</span>
              </button>

              <figcaption className="text-center mt-3 fst-italic text-muted">
                «2022-2023»
              </figcaption>
            </div>
            </div>
          <div className="col">
            <h2>Διεθνή πρώτα βήματα</h2>
            <p>
              Γνωρίζοντας ελάχιστα το άθλημα, τρία χρόνια μετά, το 2022, βρέθηκα σε τουρνουά στο εξωτερικό μαζί με την Εθνική Ομάδα. Το πρώτο που συμμετείχα ήταν στο <strong>Μαυροβούνιο</strong>, όπου αξιολογήθηκα στην <strong>Κλάση 7</strong> από την επιτροπή των γιατρών. Λίγους μήνες μετά, ούσα πλέον μέλος της Εθνικής Ομάδας, ταξιδέψαμε στην <strong>Τσεχία</strong>.
            </p>
            <p>
              Την επόμενη χρονιά, τον Σεπτέμβρη του 2023, διοργανώθηκε για δεύτερη φορά στα χρονικά του ελληνικού πινγκ πονγκ <strong>Διεθνές Τουρνουά στην Κεφαλονιά</strong>, όπου και συμμετείχα. Εκεί κατάφερα να πάρω το <strong>χάλκινο μετάλλιο</strong> στα μεικτά, με τον συμπαίκτη και φίλο <strong>Ben Ashock Despineux</strong>, με τον οποίο τυχαίνει να έχουμε το ίδιο σύνδρομο και που τώρα είναι <strong>Νο1 στον κόσμο</strong>.
              <h5>Μετά τις επιτυχίες αυτές κατατάχθηκα τον Μαΐο του 2023 <strong>Nο14</strong> στην κατηγορία μου παγκοσμίως. (<a href="http://stats.ipttc.org/en/profiles/6593/rankings">Ranking History</a>)</h5>
            </p>
            <p>
              Την ίδια χρονιά, λίγους μήνες αργότερα συμμετείχα στο <strong>Πανευρωπαϊκό Τουρνουά U23</strong> στη <strong>Φινλανδία</strong>, μαζί με ολόκληρη την Παραολυμπιακή Ομάδα.
            </p>
          </div>
        </div>
        </article>

        <article className="card">
        <div className="row gx-5 align-items-center">
        <div className="col-7">
            <h2>Singapore Smash Event</h2>
            <p>
              Το μεγαλύτερο και πιο σημαντικό γεγονός της πορείας μου ήταν η συμμετοχή στο <strong>Singapore Smash Event</strong> στη <strong>Σιγκαπούρη</strong> — το μεγαλύτερο αθλητικό event στον κόσμο του πινγκ πονγκ. Για πρώτη φορά, το 2024, διοργανώθηκαν παράλληλα δύο events: ένα για αρτιμελείς αθλητές και ένα <em>showcase event</em> για αθλητές με αναπηρία, όπου η συμμετοχή ήταν δυνατή μόνο με πρόσκληση!
            </p>
            <p>
              Εκεί είχα την τιμή να αντιμετωπίσω το <strong>Νο2</strong> της κατηγορίας μου, χωρίς καθοδήγηση και προπονητή, σε έναν απίστευτο αγώνα με πολύ μεγάλο ανταγωνισμό.
            </p>
          </div>
        <div className="col">
          <img src="images\SingaporeSmash.jpg" alt="Singapore Smash" style={{width:"450px"}}/>
          </div>
        </div>
        </article>

        <article className="card">
          <div className="row gx-5 align-items-center">

        <div className="col">
        
          <img src="/images/prokrimatika.jpg" alt="Η Καϊπη Μαρία Ισμήνη σε προπόνηση με τον ομοσπονδιακό προπονητή Σωτήρη Ζήκο" style={{width:"400px"}}/>
          </div>
          <div className="col-7">
            <h2>Νέες επιτυχίες στην Ελλάδα</h2>
            <p>
              Μετά από αυτές τις πολύτιμες εμπειρίες, το <strong>2025</strong> συμμετείχα για πρώτη φορά στο <strong>Πανελλήνιο Πρωτάθλημα Αρτιμελών Γυναικών</strong> στο <strong>Σ.Ε.Φ.</strong>.
              Υπό τις συστηματικές προπονήσεις, ακόμη και το καλοκαίρι, από τις αρχές του 2023 με τον Ομοσπονδιακό Προπονητή <strong>Σωτήρη Ζήκο</strong>, κατάφερα να προκριθώ μεταξύ των γυναικών στην τελική φάση του Πρωταθλήματος, αφήνοντας ιστορία. ( <a href="/#prokrimatika">Δες εδώ</a> )
            </p>
            <p>
              Το <strong>2026</strong> αναμένεται εξίσου δυναμικό, με συμμετοχές ξανά σε τέσσερις διοργανώσεις: <strong>Β' Εθνική Γυναικών</strong>, <strong>Πανελλήνιο Αρτιμελών</strong>, <strong>Πανελλήνιο ΑΜΕΑ</strong> και <strong>Πρωτάθλημα Βετεράνων & Κυπέλλου</strong>, που θα διεξαχθούν στην Πάτρα, στα πλαίσια των Πρωταθλημάτων Δυτικής Ελλάδας.
            </p>
          </div>  
        </div>
        </article>

        <article className="card card--accent">
          <h2>Ο δρόμος προς το Λος Άντζελες</h2>
          <p>
            Ο στόχος αρχικά ήταν να μάθω το άθλημα. Πλέον οι επιδόσεις έχουν αρχίσει και φαίνονται έντονα, και ο τελικός στόχος φαντάζει βουνό αλλά όχι ακατόρθωτος: <strong>Παραολυμπιακοί Αγώνες 2028, Λος Άντζελες</strong>.
          </p>
          <p>
            Ελπίζουμε οι κόποι να αποδώσουν τους καρπούς που πρέπει, ώστε να μπορέσουμε —ίσως για πρώτη φορά στην ιστορία— να εκπροσωπήσουμε τη χώρα σε παγκόσμιο επίπεδο ως γυναίκες με αναπηρία και να δείξουμε ότι τίποτα δεν είναι ακατόρθωτο, αν στο λέει η ψυχή σου.
          </p>
        </article>
      </section>

      {/* Χρονολόγιο */}
      <section className="timeline container" aria-label="Ορόσημα">
        <h2 className="timeline__title">Ορόσημα</h2>
        <ol className="timeline__list">
          <li>
            <h3>2019 — Πρώτα χρυσά</h3>
            <p>1η συμμετοχή &amp; 1η θέση στο Πανελλήνιο ΑΜΕΑ.</p>
          </li>
          <li>
            <h3>2022 — Διεθνές ντεμπούτο</h3>
            <p>Μαυροβούνιο (Κλάση 7), Τσεχία, Κεφαλονιά (Χάλκινο στα μεικτά).</p>
          </li>
          <li>
            <h3>2023 — U23 Ευρώπη</h3>
            <p>Συμμετοχή με την Παραολυμπιακή Ομάδα στη Φινλανδία.</p>
          </li>
          <li>
            <h3>2024 — Singapore Smash</h3>
            <p>Αγώνας επίδειξης με το Νο2 παγκοσμίως.</p>
          </li>
          <li>
            <h3>2025 — Ιστορική πρόκριση</h3>
            <p>Πρόκριση στην τελική φάση Πανελληνίου Αρτιμελών.</p>
          </li>
          <li>
            <h3>2026 → 2028 — Ο τελικός στόχος</h3>
            <p>Συμμετοχές σε τέσσερις διοργανώσεις &amp; προετοιμασία για τους Παραολυμπιακούς 2028.</p>
          </li>
        </ol>
      </section>
    </main>
  );
};

export default AboutGr;
